import type { ReactNode } from 'react';
import clsx from 'clsx';
import { Inbox } from 'lucide-react';

export interface EmptyStateProps {
  title: string;
  description?: ReactNode;
  /** Иконка lucide-react; по умолчанию — «пустой лоток». */
  icon?: ReactNode;
  /** Кнопка действия («Создать выпуск», «Сбросить фильтры»). */
  action?: ReactNode;
  className?: string;
}

export function EmptyState({ title, description, icon, action, className }: EmptyStateProps) {
  return (
    <div
      className={clsx(
        'flex flex-col items-center justify-center gap-2 px-6 py-12 text-center',
        className,
      )}
    >
      <div className="text-slate-300">
        {icon ?? <Inbox className="h-10 w-10" aria-hidden />}
      </div>
      <p className="text-base font-medium text-slate-700">{title}</p>
      {description ? <p className="max-w-md text-sm text-slate-500">{description}</p> : null}
      {action ? <div className="mt-2">{action}</div> : null}
    </div>
  );
}
